import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHandshake,FaLeaf, FaUsers, FaArrowRight, FaBuilding, FaAward, FaLightbulb, } from 'react-icons/fa';
import { MdArchitecture, MdSecurity, MdTrendingUp } from 'react-icons/md';

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div style={styles.pageContainer}>
      {/* Enhanced Hero Section */}
      <div style={styles.heroSection}>
        <div style={styles.heroBackground} />
        <div style={styles.heroContent}>
          <div style={styles.heroOverlay}>
            <div style={styles.heroTextContainer}>
              <h1 style={styles.heroTitle}>TEMELDEN</h1>
              <div style={styles.heroDivider}></div>
              <p style={styles.heroSubtitle}>Yeni Nesil Proje Platformu</p>
              <p style={styles.heroDescription}>
                İnşaatı temelden başlayan konut projelerini, güvenilir firmalarla yatırım yapmak isteyen müşterilerle buluşturuyoruz.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Expertise Section */}
      <div style={styles.section}>
        <div style={styles.sectionContent}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Uzmanlık Alanlarımız</h2>
            <p style={styles.sectionSubtitle}>
              Gayrimenkul sektöründeki derin bilgi birikimimizle hizmetinizdeyiz
            </p>
          </div>
          <div style={styles.expertiseGrid}>
            <div style={styles.expertiseCard}>
              <div style={styles.expertiseIconWrapper}>
                <FaBuilding style={styles.expertiseIcon} />
              </div>
              <h3 style={styles.expertiseTitle}>Konut Projeleri</h3>
              <p style={styles.expertiseText}>
                Modern yaşam alanları tasarlayarak müşterilerimize en kaliteli konut projelerini sunuyoruz
              </p>
            </div>
            <div style={styles.expertiseCard}>
              <div style={styles.expertiseIconWrapper}>
                <MdTrendingUp style={styles.expertiseIcon} />
              </div>
              <h3 style={styles.expertiseTitle}>Yatırım Danışmanlığı</h3>
              <p style={styles.expertiseText}>
                Gayrimenkul yatırımlarınız için stratejik danışmanlık ve portföy yönetimi hizmeti
              </p>
            </div>
            <div style={styles.expertiseCard}>
              <div style={styles.expertiseIconWrapper}>
                <MdArchitecture style={styles.expertiseIcon} />
              </div>
              <h3 style={styles.expertiseTitle}>Proje Geliştirme</h3>
              <p style={styles.expertiseText}>
                Arzadan teslimata kadar tüm süreçlerde profesyonel proje yönetimi
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mission & Vision Section */}
      <div style={{ ...styles.section, backgroundColor: '#f8f9fa' }}>
        <div style={styles.sectionContent}>
          <div style={styles.missionVisionGrid}>
            <div style={styles.missionCard}>
              <div style={styles.iconWrapper}>
                <FaBuilding style={styles.missionIcon} />
              </div>
              <h2 style={styles.missionTitle}>Misyonumuz</h2>
              <p style={styles.missionText}>
                Müşteri memnuniyetini merkeze alarak, şeffaf ve güvenilir gayrimenkul 
                danışmanlığı ile hayallerinizdeki yaşam alanlarını profesyonelce inşa etmek.
                Kalite standartlarımızdan ödün vermeden, sektördeki en iyi uygulamaları 
                takip ederek müşterilerimize değer katıyoruz.
              </p>
            </div>
            <div style={styles.missionCard}>
              <div style={styles.iconWrapper}>
                <MdTrendingUp style={styles.missionIcon} />
              </div>
              <h2 style={styles.missionTitle}>Vizyonumuz</h2>
              <p style={styles.missionText}>
                Sektörde lider ve yenilikçi bir marka olarak, müşterilerimize en kaliteli 
                gayrimenkul hizmetlerini sunmak ve sürdürülebilir değer yaratmak.
                Uluslararası standartlarda projeler geliştirerek, Türkiye gayrimenkul 
                sektörünün lokomotifi olmayı hedefliyoruz.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Values Section */}
<div style={styles.section}>
  <div style={styles.sectionContent}>
    <div style={styles.sectionHeader}>
      <h2 style={styles.sectionTitle}>Değerlerimiz</h2>
      <p style={styles.sectionSubtitle}>
        Kalite, güven ve mükemmeliyetçilik ilkeleriyle hizmet veriyoruz
      </p>
    </div>

    <div style={styles.valuesGrid}>
      <div style={styles.valueCard}>
        <div style={styles.valueIconContainer}>
          <MdSecurity style={styles.valueIcon} />
        </div>
        <h3 style={styles.valueTitle}>Güven ve Şeffaflık</h3>
        <p style={styles.valueText}>
          Tüm süreçlerde açık iletişim ve dürüstlük ilkeleriyle hareket ediyoruz
        </p>
      </div>

      <div style={styles.valueCard}>
        <div style={styles.valueIconContainer}>
          <FaAward style={styles.valueIcon} />
        </div>
        <h3 style={styles.valueTitle}>Kalite Standartları</h3>
        <p style={styles.valueText}>
          Uluslararası kalite standartlarında projeler geliştiriyoruz
        </p>
      </div>

      <div style={styles.valueCard}>
        <div style={styles.valueIconContainer}>
          <FaUsers style={styles.valueIcon} />
        </div>
        <h3 style={styles.valueTitle}>Müşteri Odaklılık</h3>
        <p style={styles.valueText}>
          İhtiyaç ve beklentileriniz bizim için her zaman öncelikli
        </p>
      </div>

      <div style={styles.valueCard}>
        <div style={styles.valueIconContainer}>
          <FaLightbulb style={styles.valueIcon} />
        </div>
        <h3 style={styles.valueTitle}>Yenilikçi Yaklaşım</h3>
        <p style={styles.valueText}>
          Sektördeki gelişmeleri takip ederek yenilikçi çözümler sunuyoruz
        </p>
      </div>

      <div style={styles.valueCard}>
        <div style={styles.valueIconContainer}>
          <FaLeaf style={styles.valueIcon} />
        </div>
        <h3 style={styles.valueTitle}>Sürdürülebilirlik</h3>
        <p style={styles.valueText}>
          Çevreye duyarlı, uzun vadeli ve sürdürülebilir projeler geliştiriyoruz
        </p>
      </div>

      <div style={styles.valueCard}>
        <div style={styles.valueIconContainer}>
          <FaHandshake style={styles.valueIcon} />
        </div>
        <h3 style={styles.valueTitle}>Ekip Ruhu</h3>
        <p style={styles.valueText}>
          Başarıya giden yolda güçlü bir ekip ruhu ve iş birliğiyle ilerliyoruz
        </p>
      </div>
    </div>
  </div>
</div>


      {/* Process Section */}
      <div style={{ ...styles.section, backgroundColor: '#f8f9fa' }}>
        <div style={styles.sectionContent}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Çalışma Sürecimiz</h2>
            <p style={styles.sectionSubtitle}>
              Profesyonel hizmet anlayışımızla her adımda yanınızdayız
            </p>
          </div>
          <div style={styles.processGrid}>
            <div style={styles.processStep}>
              <div style={styles.stepNumber}>01</div>
              <h3 style={styles.stepTitle}>İhtiyaç Analizi</h3>
              <p style={styles.stepText}>
                Müşteri ihtiyaçlarını detaylı şekilde analiz ediyor, en uygun çözümleri belirliyoruz
              </p>
            </div>
            <div style={styles.processStep}>
              <div style={styles.stepNumber}>02</div>
              <h3 style={styles.stepTitle}>Proje Geliştirme</h3>
              <p style={styles.stepText}>
                Uzman ekibimizle birlikte detaylı proje planlaması ve geliştirme sürecini yönetiyoruz
              </p>
            </div>
            <div style={styles.processStep}>
              <div style={styles.stepNumber}>03</div>
              <h3 style={styles.stepTitle}>Kalite Kontrol</h3>
              <p style={styles.stepText}>
                Tüm aşamalarda titiz kalite kontrolü ile standartlarımızı garanti altına alıyoruz
              </p>
            </div>
            <div style={styles.processStep}>
              <div style={styles.stepNumber}>04</div>
              <h3 style={styles.stepTitle}>Teslimat ve Sonrası</h3>
              <p style={styles.stepText}>
                Anahtar teslim projelerle birlikte kapsamlı sonrası hizmet desteği sunuyoruz
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced CTA Section */}
      <div style={styles.section}>
        <div style={styles.ctaContainer}>
          <div style={styles.ctaContent}>
            <h2 style={styles.ctaTitle}>Profesyonel Çözüm Ortağınız</h2>
            <p style={styles.ctaText}>
              Gayrimenkul yatırımlarınızda uzman danışmanlık hizmeti almak için 
              bizimle iletişime geçin. Hayalinizdeki projeyi birlikte gerçekleştirelim.
            </p>
            <div style={styles.ctaButtons}>
              <button 
                onClick={() => navigate('/iletisim')} 
                style={styles.primaryButton}
              >
                <span>İletişime Geçin</span>
                <FaArrowRight style={styles.buttonIcon} />
              </button>
              <button 
                onClick={() => navigate('/projects')} 
                style={styles.secondaryButton}
              >
                Projelerimizi İnceleyin
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageContainer: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    color: '#2d3748',
    lineHeight: 1.6,
  },
  heroSection: {
    height: '70vh',
    minHeight: '650px',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  heroBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: 'url(/images/AboutPage/aboutpage/aboutpage.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    filter: 'brightness(0.4)',
    zIndex: 1,
  },
  heroContent: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  heroOverlay: {
    textAlign: 'center',
    maxWidth: '800px',
    padding: '0 20px',
  },
  heroTextContainer: {
    background: 'rgba(255, 255, 255, 0.95)',
    padding: '60px 40px',
    borderRadius: '20px',
    boxShadow: '0 20px 60px rgba(0, 30, 120, 0.1)',
  },
  heroTitle: {
    fontSize: '4rem',
    fontWeight: '800',
    marginBottom: '20px',
    color: '#001e78',
    letterSpacing: '2px',
  },
  heroDivider: {
    width: '80px',
    height: '4px',
    backgroundColor: '#FFC107',
    margin: '0 auto 30px auto',
    borderRadius: '2px',
  },
  heroSubtitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#001e78',
    marginBottom: '20px',
  },
  heroDescription: {
    fontSize: '1.1rem',
    color: '#4a5568',
    maxWidth: '600px',
    margin: '0 auto',
  },
  section: {
    padding: '100px 0',
  },
  sectionContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
  },
  sectionHeader: {
    textAlign: 'center',
    marginBottom: '60px',
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: '700',
    color: '#001e78',
    marginBottom: '15px',
  },
  sectionSubtitle: {
    fontSize: '1.2rem',
    color: '#718096',
    maxWidth: '600px',
    margin: '0 auto',
  },
  expertiseGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '40px',
  },
  expertiseCard: {
    backgroundColor: 'white',
    padding: '50px 30px',
    borderRadius: '12px',
    textAlign: 'center',
    boxShadow: '0 5px 25px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
    transition: 'transform 0.3s ease',
  },
  expertiseIconWrapper: {
    width: '80px',
    height: '80px',
    backgroundColor: '#f7f9fc',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 30px auto',
    border: '2px solid #e2e8f0',
  },
  expertiseIcon: {
    fontSize: '2rem',
    color: '#001e78',
  },
  expertiseTitle: {
    fontSize: '1.4rem',
    fontWeight: '600',
    color: '#001e78',
    marginBottom: '20px',
  },
  expertiseText: {
    fontSize: '1rem',
    lineHeight: '1.7',
    color: '#718096',
  },
  missionVisionGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))',
    gap: '50px',
  },
  missionCard: {
    backgroundColor: 'white',
    padding: '50px 40px',
    borderRadius: '15px',
    textAlign: 'center',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e2e8f0',
  },
  iconWrapper: {
    width: '80px',
    height: '80px',
    backgroundColor: '#001e78',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 30px auto',
  },
  missionIcon: {
    fontSize: '2rem',
    color: 'white',
  },
  missionTitle: {
    fontSize: '1.8rem',
    fontWeight: '600',
    color: '#001e78',
    marginBottom: '20px',
  },
  missionText: {
    fontSize: '1.1rem',
    lineHeight: '1.7',
    color: '#4a5568',
  },
  valuesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '30px',
  },
  valueCard: {
    backgroundColor: 'white',
    padding: '40px 30px',
    borderRadius: '12px',
    textAlign: 'center',
    boxShadow: '0 5px 25px rgba(0, 0, 0, 0.06)',
    border: '1px solid #f1f1f1',
  },
  valueIconContainer: {
    width: '70px',
    height: '70px',
    backgroundColor: '#f7f9fc',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 25px auto',
    border: '1px solid #e2e8f0',
  },
  valueIcon: {
    fontSize: '1.8rem',
    color: '#001e78',
  },
  valueTitle: {
    fontSize: '1.4rem',
    fontWeight: '600',
    color: '#001e78',
    marginBottom: '15px',
  },
  valueText: {
    fontSize: '1rem',
    lineHeight: '1.6',
    color: '#718096',
  },
  processGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '40px',
  },
  processStep: {
    textAlign: 'center',
    padding: '40px 20px',
  },
  stepNumber: {
    fontSize: '3rem',
    fontWeight: '800',
    color: '#001e78',
    marginBottom: '20px',
    opacity: 0.1,
  },
  stepTitle: {
    fontSize: '1.3rem',
    fontWeight: '600',
    color: '#001e78',
    marginBottom: '15px',
  },
  stepText: {
    fontSize: '1rem',
    lineHeight: '1.6',
    color: '#718096',
  },
  ctaContainer: {
    backgroundColor: '#001e78',
    borderRadius: '20px',
    overflow: 'hidden',
  },
  ctaContent: {
    padding: '80px 40px',
    textAlign: 'center',
  },
  ctaTitle: {
    fontSize: '2.5rem',
    fontWeight: '700',
    color: 'white',
    marginBottom: '20px',
  },
  ctaText: {
    fontSize: '1.2rem',
    color: 'rgba(255, 255, 255, 0.9)',
    maxWidth: '700px',
    margin: '0 auto 40px auto',
    lineHeight: '1.7',
  },
  ctaButtons: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  primaryButton: {
    backgroundColor: 'white',
    color: '#001e78',
    padding: '18px 40px',
    fontSize: '1.1rem',
    fontWeight: '600',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    transition: 'all 0.3s ease',
  },
  secondaryButton: {
    backgroundColor: 'transparent',
    color: 'white',
    padding: '18px 40px',
    fontSize: '1.1rem',
    fontWeight: '600',
    border: '2px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  buttonIcon: {
    fontSize: '1rem',
  },
};